import { ILoadingError } from './useLoadingErrorCatcher.types';
import { allPass, anyPass, complement, equals, pathEq, pathOr, propEq, propSatisfies } from 'ramda';
import { isTruthy } from 'ramda-adjunct';

type TErrorChecker = (error: ILoadingError) => boolean;

export const isNetworkError: TErrorChecker = (error) => {
  return Boolean(error) && propEq('message', 'Network Error', error);
};

export const isNotAuthorizedError: TErrorChecker = (error) =>
  Boolean(error) && propSatisfies(anyPass([equals(401), equals(403)]), 'code', error);

export const isCancelError = (error: ILoadingError): boolean => Boolean(error) && propEq('message', 'cancelled', error);

export const isRecommendedHomeError: TErrorChecker = pathEq(['data', 'source'], 'recommended');

export const isUnknownLoadingError: TErrorChecker = allPass([
  isTruthy,
  complement(anyPass([isNotAuthorizedError, isRecommendedHomeError, isCancelError, isNetworkError])),
]);

export const getErrorMessage = (error: ILoadingError): string =>
  error.message ||
  pathOr<string, string>('', ['data', 'message'], error) ||
  pathOr<string, string>('', ['data', 'error_description'], error) ||
  pathOr<string, string>('', ['data', 'error_info', 'message'], error);
